import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'O',
    name: 'Expérience 153',
    id: 'Experiment153',
    health: '*',
    difficulty: 3,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'O',
    name: 'Voleur de Rêves',
    id: 'ThiefOfDreams',
    health: 80,
    difficulty: 4,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'O',
    name: '',
    id: 'Nécrosbire',
    health: 50,
    difficulty: 5,
    expeditionRating: 3,
    additionalInfo: '',
  },
  {
    expansion: 'O',
    name: 'Fontaine des Âmes',
    id: 'FountainOfSouls',
    health: 70,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
  },
]
